import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Telehealth = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="telehealth icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 8C17 5.23858 19.2386 3 22 3H42C44.7614 3 47 5.23858 47 8V50C47 52.7614 44.7614 55 42 55H22C19.2386 55 17 52.7614 17 50V8ZM14 8V50V53V56C14 60.4183 17.5817 64 22 64H42C46.4183 64 50 60.4183 50 56V53V50V8C50 3.58172 46.4183 0 42 0H22C17.5817 0 14 3.58172 14 8ZM27.5 58C26.6716 58 26 58.6716 26 59.5C26 60.3284 26.6716 61 27.5 61H36.5C37.3284 61 38 60.3284 38 59.5C38 58.6716 37.3284 58 36.5 58H27.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 55V45C42 39.4772 37.5228 35 32 35C26.4772 35 22 39.4772 22 45V55H42ZM32 32C24.8203 32 19 37.8203 19 45V58H45V45C45 37.8203 39.1797 32 32 32Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M29 34H35V55H29V34Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 25V19C39 15.134 35.866 12 32 12C28.134 12 25 15.134 25 19V25C25 28.866 28.134 32 32 32C35.866 32 39 28.866 39 25ZM32 9C26.4772 9 22 13.4772 22 19V25C22 30.5228 26.4772 35 32 35C37.5228 35 42 30.5228 42 25V19C42 13.4772 37.5228 9 32 9Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 25C22.5523 25 23 24.5523 23 24C23 23.4477 22.5523 23 22 23C21.4477 23 21 23.4477 21 24C21 24.5523 21.4477 25 22 25ZM25 24C25 25.6569 23.6569 27 22 27C20.3431 27 19 25.6569 19 24C19 22.3431 20.3431 21 22 21C23.6569 21 25 22.3431 25 24Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 25C42.5523 25 43 24.5523 43 24C43 23.4477 42.5523 23 42 23C41.4477 23 41 23.4477 41 24C41 24.5523 41.4477 25 42 25ZM45 24C45 25.6569 43.6569 27 42 27C40.3431 27 39 25.6569 39 24C39 22.3431 40.3431 21 42 21C43.6569 21 45 22.3431 45 24Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.8267 25.9375C29.5186 25.4845 28.9022 25.3635 28.4453 25.6681C27.9858 25.9744 27.8616 26.5953 28.1679 27.0548L29 26.5001C28.1679 27.0548 28.1682 27.0552 28.1684 27.0556L28.169 27.0564L28.1701 27.0581L28.1727 27.0619L28.1791 27.0713L28.1967 27.0965C28.2106 27.116 28.2289 27.141 28.2514 27.1706C28.2965 27.2298 28.3593 27.308 28.4401 27.3988C28.6009 27.5797 28.8369 27.8153 29.15 28.0501C29.7792 28.522 30.7345 29.0001 32 29.0001C33.2655 29.0001 34.2208 28.522 34.85 28.0501C35.1631 27.8153 35.3991 27.5797 35.5599 27.3988C35.6406 27.308 35.7035 27.2298 35.7485 27.1706C35.7711 27.141 35.7893 27.116 35.8032 27.0965L35.8208 27.0713L35.8272 27.0619L35.8298 27.0581L35.831 27.0564L35.8315 27.0556C35.8318 27.0552 35.832 27.0548 35 26.5001L35.832 27.0548C36.1384 26.5953 36.0142 25.9744 35.5547 25.6681C35.0954 25.3619 34.4749 25.4857 34.1684 25.9447L34.1689 25.944L34.1698 25.9427L34.1713 25.9404L34.1733 25.9375C34.1742 25.9362 34.1742 25.9362 34.1733 25.9374C34.1716 25.9399 34.1664 25.9471 34.1577 25.9585C34.1403 25.9814 34.1093 26.0203 34.0651 26.0701C33.9759 26.1705 33.8369 26.3099 33.65 26.4501C33.2792 26.7282 32.7345 27.0001 32 27.0001C31.2655 27.0001 30.7208 26.7282 30.35 26.4501C30.1631 26.3099 30.0241 26.1705 29.9349 26.0701C29.8906 26.0203 29.8597 25.9814 29.8423 25.9585C29.8337 25.9473 29.8285 25.9401 29.8267 25.9375Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1311 16.0086C34.46 16.0522 34.746 16.256 34.8944 16.5528C35.3155 17.395 36.0849 18.2873 36.9371 18.9691C37.3585 19.3062 37.7777 19.5737 38.1553 19.7528C38.5446 19.9376 38.8295 20 39 20C39.5522 20 40 20.4477 40 21C40 21.5523 39.5522 22 39 22C38.4204 22 37.8303 21.8124 37.2978 21.5597C36.7534 21.3014 36.2039 20.9438 35.6878 20.5309C35.0143 19.9921 34.3592 19.3279 33.8249 18.6065C30.5387 21.6502 26.6601 22.171 24.9004 21.995C24.3509 21.9401 23.95 21.4501 24.0049 20.9005C24.0599 20.351 24.5499 19.95 25.0995 20.005C26.5052 20.1455 30.3015 19.6555 33.2525 16.3356C33.473 16.0876 33.8021 15.9651 34.1311 16.0086Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="26"
      y="33"
      width="3"
      height="22"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="35"
      y="33"
      width="3"
      height="22"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
